import script from "./table.widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./table.widget.vue?vue&type=script&lang=ts&setup=true"

import "./table.widget.vue?vue&type=style&index=0&id=90c3ac0a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c3ac0a"]])

export default __exports__